/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * Check if a given object implements the ViewIncidentFileResponse interface.
 */
export function instanceOfViewIncidentFileResponse(value) {
    let isInstance = true;
    return isInstance;
}
export function ViewIncidentFileResponseFromJSON(json) {
    return ViewIncidentFileResponseFromJSONTyped(json, false);
}
export function ViewIncidentFileResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'uploadMimeType': !exists(json, 'uploadMimeType') ? undefined : json['uploadMimeType'],
        'uploadFileName': !exists(json, 'uploadFileName') ? undefined : json['uploadFileName'],
        'thumbnailUrl': !exists(json, 'thumbnailUrl') ? undefined : json['thumbnailUrl'],
        'previewUrl': !exists(json, 'previewUrl') ? undefined : json['previewUrl'],
        'convertedObjectUrl': !exists(json, 'convertedObjectUrl') ? undefined : json['convertedObjectUrl'],
    };
}
export function ViewIncidentFileResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'uploadMimeType': value.uploadMimeType,
        'uploadFileName': value.uploadFileName,
        'thumbnailUrl': value.thumbnailUrl,
        'previewUrl': value.previewUrl,
        'convertedObjectUrl': value.convertedObjectUrl,
    };
}
